    $(document).ready(function() {
        // Функция для открытия вопроса
        function openQuestion($question) {
            var $answer = $question.parent().find('div.answer');
            //не закрываем остальные вопросы...
            //$('.faq-list-classic .question').removeClass('opened');
            //$('.faq-list-classic div.answer').slideUp(300).css('opacity', 0);
            $question.addClass('opened');
            $answer.slideDown(300).css('opacity', 1);
        }

        // Обработчик клика по вопросу
        $('.faq-list-classic .question').on('click', function(e) {
            e.preventDefault();
            var $this = $(this);
            var anchor_id = $this.attr('href').substring(1);
            var url = new URL(window.location);

            if ($this.hasClass('opened')) {
                $this.removeClass('opened');
                $this.parent().find('div.answer').slideUp(300).css('opacity', 0);
                url.hash = '';
                window.history.pushState({}, '', url);
            } else {
                openQuestion($this);
                url.hash = `#${anchor_id}`;
                window.history.pushState({}, '', url);
            }
        });

        // Открытие вопроса при загрузке страницы с хэшем
        if (window.location.hash) {
            var hash = window.location.hash.substring(1);
            var $question = $(`.faq-list-classic .question[href="#${hash}"]`);
            if ($question.length) {
                openQuestion($question);
                $('html, body').animate({
                    scrollTop: $question.offset().top - 100
                }, 500);
            }
        }
    });

    /**
     * По клику открывает и закрывает ответ для вопроса (используется в newbies prostobox)
     */
    eventClick('.item', function (elem) {
        const $button = $(elem).find('.switch');
        const $text = $(elem).find('.text');
        const anchor_id = $(elem).attr('id');
        const url = new URL(window.location);

        if ($button.hasClass('active') && $text.hasClass('active')) {
            $button.removeClass('active');
            $text.removeClass('active');

        } else {

            url.hash = `#${anchor_id}`;

            window.history.pushState({}, '', url);

            $button.addClass('active');
            $text.addClass('active');
        }

    });


    /**
     * При открытии страницы через якорь сделаем активным и отображаем (используется в newbies prostobox)
     */
    function checkAnchorAndMakeActive() {
        if (window.location.hash) {
            const hash = window.location.hash;

            if (hash && $(hash).length) {

                $(hash).find('.switch').addClass('active');
                $(hash).find('.text').addClass('active');
            }
        }
    }

    checkAnchorAndMakeActive();


    /**
     *   Подписка на рассылку новостей
     */
    eventClick('.main-subscription__submit', function (){
        //TODO fix route()
        request('POST', `news-subscription`, {email: $('.main-subscription__input').val()}, function (response) {
            showSuccess(response);
            $('.main-subcribe').hide();
        })
    })

    const modal = $('#myModal');

    let delay_timer;
    eventInput('.faq-search-text', function (data) {
        const search = $(data).val();
        const route = $(data).data('action');

        if (search.length <= 3){
            return false;
        }

        clearTimeout(delay_timer);

        delay_timer = setTimeout(function() {
            request('GET', route, {search}, function (response) {
                if (response.length && response !== '') {
                    $('.faq-result_list').empty();
                    $('.faq-result_list').append(response)
                    modal.show();
                }
            })
        }, 1000)
    })

    // eventClick('.faq-result_link', function (data){

    //     $('#myModal').hide();

    //     const target = $(data).attr('href');

    //     $('html, body').animate({
    //         scrollTop: $(target).offset().top
    //     }, 1000);

    //     window.location.hash = target;

    //     checkAnchorAndMakeActive();
    // })

    eventClick('.close-faq-search-modal', ()  => modal.hide())

    $(window).on('click', function(event) {
        if ($(event.target).is(modal)) {
            modal.hide();
        }
    });

    eventClick('.faq-search-button', function () {

        const search = $('.faq-search-text').val();
        const route = $('.faq-search-text').data('action');

        if (search.length <= 3) {
            return false;
        }

        request('GET', route, {search}, function (response) {
            if (response.length && response !== '') {
                $('.faq-result_list').empty();
                $('.faq-result_list').append(response)
                modal.show();
            }
        })
    })
